import React from 'react'

import { useAppContext } from 'app/fieldapp/components/core'

export type UseReloadAppData = {
  isLoading: boolean
  onRefetchAppData: () => void
}

export const useReloadAppData = (): UseReloadAppData => {
  const [isLoading, setIsLoading] = React.useState(true)

  const { isFullyInitialized, isRefetchingAppData, setIsRefetchingAppData } =
    useAppContext()

  /**
   * Callback for setting the context flag to trigger a full re-fetch of all data
   */
  const onRefetchAppData = React.useCallback(() => {
    setIsLoading(true)
    setIsRefetchingAppData(true)
  }, [setIsRefetchingAppData])
  const isInitialAppRender = React.useRef(!isFullyInitialized)

  /**
   * Handler to re-fetch all data on page load, but ONLY if this is not the first time it is loaded
   * e.g. If we are routing here from another page
   */
  React.useEffect(() => {
    if (!isInitialAppRender.current) {
      onRefetchAppData()
    }
  }, [onRefetchAppData])

  React.useEffect(() => {
    if (isRefetchingAppData) {
      setIsLoading(true)
    }

    if (isLoading && !isRefetchingAppData) {
      setIsLoading(false)
    }
  }, [isRefetchingAppData, isLoading])

  return { isLoading, onRefetchAppData }
}
